import { useState } from 'react';

const WHATSAPP_NUMBER = '905321234567'; // Gerçek numara buraya
const DEFAULT_MESSAGE = 'Merhaba! Etiket siparişi hakkında bilgi almak istiyorum. Fiyat teklifi alabilir miyim?';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    const encoded = encodeURIComponent(DEFAULT_MESSAGE);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        <div className="bg-white rounded-2xl shadow-xl px-4 py-3 flex flex-col gap-1 border border-gray-100 min-w-[200px]">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Hızlı Teklif Al</span>
          <span className="text-sm text-gray-700 leading-snug">WhatsApp üzerinden anında yanıt alın</span>
          <div className="flex items-center gap-1 mt-1">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse inline-block"></span>
            <span className="text-xs text-green-600 font-medium">Şu an aktif</span>
          </div>
        </div>
        {/* Arrow */}
        <div className="flex justify-end pr-5">
          <div className="w-3 h-3 bg-white border-r border-b border-gray-100 rotate-45 -mt-1.5 shadow-sm"></div>
        </div>
      </div>

      {/* Ana Buton */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="WhatsApp ile Hızlı Teklif Al"
        className="group relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white pl-5 pr-6 py-4 rounded-full shadow-2xl hover:shadow-green-300/60 transition-all duration-300 cursor-pointer whitespace-nowrap"
        style={{ boxShadow: '0 8px 32px rgba(37,211,102,0.45)' }}
      >
        {/* Ping animasyonu */}
        <span className="absolute -top-1 -right-1 flex h-4 w-4">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-4 w-4 bg-green-500"></span>
        </span>

        <div className="w-7 h-7 flex items-center justify-center">
          <i className="ri-whatsapp-line text-2xl"></i>
        </div>
        <div className="flex flex-col items-start leading-tight">
          <span className="text-xs font-medium opacity-90">Hızlı Teklif Al</span>
          <span className="text-sm font-bold">WhatsApp</span>
        </div>
      </button>
    </div>
  );
}
